import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Fragment as _Fragment, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "staffView__content" }
const _hoisted_3 = { class: "staffView__leftSide" }
const _hoisted_4 = {
  key: 0,
  class: "dot"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "icon icon-useradd" }, null, -1)
const _hoisted_6 = { class: "staffView__rightSide" }
const _hoisted_7 = {
  class: "text-warning",
  style: {"margin":"0 5px"}
}
const _hoisted_8 = { class: "staffView__companyName" }
const _hoisted_9 = { class: "text-primary" }
const _hoisted_10 = { class: "dropdown-icon text-primary" }
const _hoisted_11 = {
  key: 1,
  class: "staffView__companyAccount"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "｜", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", null, "｜", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", null, "如需增加可用账号数量，请联系对接商务经理或拨打 400-6030-777", -1)
const _hoisted_15 = {
  key: 2,
  class: "staffView__companytips"
}
const _hoisted_16 = { class: "staffView__controls fl-row-between" }
const _hoisted_17 = { class: "btn--gather" }
const _hoisted_18 = { style: {"margin-top":"16px"} }
const _hoisted_19 = { class: "break-word" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1)
const _hoisted_22 = ["onClick"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "separator" }, null, -1)
const _hoisted_24 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_divider = _resolveComponent("a-menu-divider")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_department_menu_new = _resolveComponent("department-menu-new")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_DownCircleOutlined = _resolveComponent("DownCircleOutlined")!
  const _component_QuestionCircleOutlined = _resolveComponent("QuestionCircleOutlined")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_BellTwoTone = _resolveComponent("BellTwoTone")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_UserInputNew = _resolveComponent("UserInputNew")!
  const _component_app_operates = _resolveComponent("app-operates")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_app_table = _resolveComponent("app-table")!
  const _component_change_department_modal = _resolveComponent("change-department-modal")!
  const _component_confirm_credit_modal = _resolveComponent("confirm-credit-modal")!
  const _component_change_rule_modal = _resolveComponent("change-rule-modal")!
  const _component_import_staff_modal = _resolveComponent("import-staff-modal")!
  const _component_invite_employees_modal = _resolveComponent("invite-employees-modal")!
  const _component_quota_adjustment = _resolveComponent("quota-adjustment")!
  const _component_staff_detail = _resolveComponent("staff-detail")!
  const _component_multiple_quota_adjustment_modal = _resolveComponent("multiple-quota-adjustment-modal")!
  const _component_AddStaff = _resolveComponent("AddStaff")!
  const _component_AddUser = _resolveComponent("AddUser")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { class: "utils__pageContainer staffView" }, {
    title: _withCtx(() => [
      _createElementVNode("div", {
        innerHTML: _ctx.sldPageTitle('#1890ff', '员工')
      }, null, 8, _hoisted_1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_a_dropdown, null, {
            overlay: _withCtx(() => [
              _createVNode(_component_a_menu, { "overlay-class-name": "staffView__menu" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_menu_item, {
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onInviteEmployees('single')))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("手机号码/邮箱邀请")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, { to: {name: 'main.staff.invite'} }, {
                        default: _withCtx(() => [
                          _createTextVNode("链接批量邀请")
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_divider),
                  _createVNode(_component_a_menu_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, { to: {name: 'main.staff.invite_link'} }, {
                        default: _withCtx(() => [
                          _createTextVNode("查看邀请记录")
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_menu_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_router_link, { to: {name: 'main.staff.invite_review'} }, {
                        default: _withCtx(() => [
                          _createTextVNode("员工加入审核 "),
                          (_ctx.inviteUserNum)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["to"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              (_ctx.authority === 0)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    key: 0,
                    class: "staffView__addDepartment",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_5,
                      _createTextVNode(" 邀请员工 "),
                      _createVNode(_component_DownOutlined)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_department_menu_new, {
            ref: "departmentMenu",
            "show-add-user": _ctx.showAddUser,
            "with-default": "",
            onChangeDepartment: _ctx.onSetDepartment,
            onChangeCompany: _ctx.onChangeCompany,
            onGetObdStatus: _ctx.getObdStatus
          }, null, 8, ["show-add-user", "onChangeDepartment", "onChangeCompany", "onGetObdStatus"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.inviteUserNum)
            ? (_openBlock(), _createBlock(_component_a_alert, {
                key: 0,
                type: "warning",
                "show-icon": "",
                style: {"margin-bottom":"15px"}
              }, {
                message: _withCtx(() => [
                  _createTextVNode(" 员工加入待审核 "),
                  _createElementVNode("span", _hoisted_7, "(" + _toDisplayString(_ctx.inviteUserNum) + ")", 1),
                  _createTextVNode(),
                  _createVNode(_component_router_link, { to: {name: 'main.staff.invite_review'} }, {
                    default: _withCtx(() => [
                      _createTextVNode("立即处理")
                    ]),
                    _: 1
                  }, 8, ["to"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createElementVNode("h2", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.currentEnterprise.enterpriseName) + "： 人数 ", 1),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.totalNum) + " 人", 1),
            _createVNode(_component_a_dropdown, null, {
              overlay: _withCtx(() => [
                _createVNode(_component_a_menu, { onClick: _ctx.handleMenuClick }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_menu_item, {
                      key: "1",
                      class: _normalizeClass({ 'handleMenu-on' : !_ctx.deptAllChildNodeFlag }),
                      onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.deptAllChildNodeFlag = false; _ctx.onRefreshTable})
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 显示当前部门 ")
                      ]),
                      _: 1
                    }, 8, ["class"]),
                    _createVNode(_component_a_menu_item, {
                      key: "2",
                      class: _normalizeClass({ 'handleMenu-on' : _ctx.deptAllChildNodeFlag }),
                      onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.deptAllChildNodeFlag = true; _ctx.onRefreshTable})
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" 显示当前及所有子部门 ")
                      ]),
                      _: 1
                    }, 8, ["class"])
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_10, [
                  _createVNode(_component_DownCircleOutlined)
                ])
              ]),
              _: 1
            })
          ]),
          (_ctx.accountCount.accountCountLimitFlag)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createTextVNode(" 可用账号数量：" + _toDisplayString(_ctx.accountCount.accountCountMax), 1),
                _hoisted_12,
                _createTextVNode("已使用：" + _toDisplayString(_ctx.accountCount.enterpriseAccountCount), 1),
                _hoisted_13,
                _createTextVNode("剩余可用："),
                _createElementVNode("i", null, _toDisplayString(_ctx.accountCount.availableEnterpriseAccount), 1),
                _createVNode(_component_a_popover, { placement: "right" }, {
                  content: _withCtx(() => [
                    _hoisted_14
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_QuestionCircleOutlined, {
                      "two-tone-color": "#989898",
                      style: {"font-size":"16px"}
                    })
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (_ctx.accountCount.accountCountLimitFlag && _ctx.accountCount.description)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_BellTwoTone, {
                  "two-tone-color": "#FF4027",
                  style: {"font-size":"14px"}
                }),
                _createTextVNode(" " + _toDisplayString(_ctx.accountCount.description), 1)
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_a_form, {
            class: "staffView__filterForm",
            form: _ctx.filterParams,
            layout: 'inline'
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_app_operates, {
                  pg: "0 7px 16px",
                  jc: "space-between"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_17, [
                      (_ctx.showAddUser && !_ctx.showButtons)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            type: "primary",
                            onClick: _ctx.addUser
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("添加临时用户")
                            ]),
                            _: 1
                          }, 8, ["onClick"]))
                        : _createCommentVNode("", true),
                      (_ctx.showButtons)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              onClick: _ctx.addStaff
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("添加员工")
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            (_ctx.authority === 0)
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 0,
                                  type: "primary",
                                  onClick: _ctx.onChangeDepartment
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("调整部门")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.authority === 0)
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 1,
                                  type: "primary",
                                  onClick: _ctx.onChangeRule
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("批量设置制度")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_a_button, {
                              type: "primary",
                              onClick: _ctx.onAdjustDepartment
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("批量调整额度")
                              ]),
                              _: 1
                            }, 8, ["onClick"]),
                            _createVNode(_component_a_dropdown, null, {
                              overlay: _withCtx(() => [
                                _createVNode(_component_a_menu, { onClick: _ctx.onAddQuota }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_menu_item, { key: "1" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("普通额度调整")
                                      ]),
                                      _: 1
                                    }),
                                    (_ctx.isScheduleModel)
                                      ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "2" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("定期额度调整")
                                          ]),
                                          _: 1
                                        }))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, { type: "primary" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(" 模版额度调整"),
                                    _createVNode(_component_DownOutlined)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_ctx.authority === 0)
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 2,
                                  type: "primary",
                                  onClick: _ctx.onImport
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("导入员工")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]))
                              : _createCommentVNode("", true),
                            (_ctx.authority === 0)
                              ? (_openBlock(), _createBlock(_component_a_button, {
                                  key: 3,
                                  type: "primary",
                                  loading: _ctx.exporting,
                                  disabled: _ctx.exporting,
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onExport($event)))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("导出员工")
                                  ]),
                                  _: 1
                                }, 8, ["loading", "disabled"]))
                              : _createCommentVNode("", true)
                          ], 64))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_checkbox, {
                        checked: _ctx.filterParams.state,
                        "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterParams.state) = $event)),
                        style: {"margin-top":"16px"}
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("展示已离职员工")
                        ]),
                        _: 1
                      }, 8, ["checked"])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_UserInputNew, {
                        style: {"width":"200px"},
                        status: "ALL",
                        value: _ctx.filterParams.userCode,
                        text: _ctx.filterParams.nameOrPhone,
                        "onUpdate:value": _ctx.onSearchUser,
                        "onUpdate:text": _ctx.onSearchUserText
                      }, null, 8, ["value", "text", "onUpdate:value", "onUpdate:text"])
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }, 8, ["form"]),
          _createVNode(_component_app_table, {
            ref: "tableRef",
            size: "default",
            "row-key": "userCode",
            columns: _ctx.tableColumns,
            data: _ctx.loadTableData,
            "row-selection": _ctx.tableOptions.rowSelection,
            "show-pagination": true,
            scroll: { x: true }
          }, {
            departmentName: _withCtx(({ record }) => [
              _createElementVNode("span", _hoisted_19, _toDisplayString(record.departmentName), 1)
            ]),
            state: _withCtx(({ record }) => [
              (!record.tempAccount)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (record.state === 'ON')
                      ? (_openBlock(), _createBlock(_component_a_tag, {
                          key: 0,
                          color: "green"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("在职")
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_a_tag, {
                          key: 1,
                          color: "red"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("离职")
                          ]),
                          _: 1
                        }))
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            action: _withCtx(({ record }) => [
              (!record.tempAccount)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: "#",
                    onClick: _withModifiers(($event: any) => (_ctx.showDrawerOfDetail(record)), ["prevent"])
                  }, "详情", 8, _hoisted_20))
                : _createCommentVNode("", true),
              ((record.state !== 'QUIT' && !record.tempAccount))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_21,
                    _createElementVNode("a", {
                      href: "javascript:;",
                      onClick: _withModifiers(($event: any) => (_ctx.onQuotaAdjust(record)), ["prevent"])
                    }, "额度管理", 8, _hoisted_22)
                  ], 64))
                : _createCommentVNode("", true),
              (!(+record.roleFlag))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _hoisted_23,
                    _createElementVNode("a", {
                      href: "#",
                      class: _normalizeClass({ 'text-fall': record.accountStatus === 1 }),
                      onClick: _withModifiers(($event: any) => (_ctx.onSwitchUserStatus(record)), ["prevent"])
                    }, "账号" + _toDisplayString(record.accountStatus === 1 ? '禁用' : '启用'), 11, _hoisted_24)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "data", "row-selection"])
        ])
      ]),
      _createVNode(_component_change_department_modal, {
        ref: "changeDepartmentModalRef",
        adjustfromdepartmentid: _ctx.filterParams.departmentId,
        onClose: _ctx.onChangeKey,
        onComplete: _ctx.onRefreshTable
      }, null, 8, ["adjustfromdepartmentid", "onClose", "onComplete"]),
      _createVNode(_component_confirm_credit_modal, { ref: "confirmCreditModalRef" }, null, 512),
      _createVNode(_component_change_rule_modal, {
        ref: "changeRuleRef",
        onClose: _ctx.onChangeKey,
        onComplete: _ctx.onRefreshTable
      }, null, 8, ["onClose", "onComplete"]),
      _createVNode(_component_import_staff_modal, {
        ref: "importStaffRef",
        onComplete: _ctx.onRefreshTable
      }, null, 8, ["onComplete"]),
      _createVNode(_component_invite_employees_modal, {
        ref: "inviteEmployeesRef",
        "add-model-type": _ctx.addModelType
      }, null, 8, ["add-model-type"]),
      _createVNode(_component_quota_adjustment, {
        ref: "quotaAdjustRef",
        onComplete: _ctx.onRefreshTable
      }, null, 8, ["onComplete"]),
      _createVNode(_component_staff_detail, {
        ref: "refDrawerOfDetail",
        "obd-status": _ctx.obdStatus,
        onComplete: _ctx.onRefreshTable
      }, null, 8, ["obd-status", "onComplete"]),
      _createVNode(_component_multiple_quota_adjustment_modal, { ref: "multipleQuotaAdjustmentRef" }, null, 512),
      (_ctx.addStaffVisible)
        ? (_openBlock(), _createBlock(_component_AddStaff, {
            key: 0,
            onComplete: _ctx.addStaffComplete
          }, null, 8, ["onComplete"]))
        : _createCommentVNode("", true),
      (_ctx.addUserVisible)
        ? (_openBlock(), _createBlock(_component_AddUser, {
            key: 1,
            onComplete: _ctx.addStaffComplete
          }, null, 8, ["onComplete"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}